import zhCn from 'ant-design-vue/es/locale/zh_CN'
const customZh = {
  login: {
    title: '欢迎登录',
    rule: {
      name: '请输入用户名',
      pwd: '请输入密码'
    }
  },
  button: {
    login: '登录',
    import: '导入',
    export: '导出',
    create: '新建',
    delete: '删除',
    renovate: '刷新',
    searchCriteria: '查询条件'
  }
}

const zh = Object.assign(zhCn, customZh)

export { zh }
